import { useState } from "react";

import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { SavedSearchesDto } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types/dto";
import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/sub-modules/my-list/services/queries/queryKeyFactory";
import type { ListsDto } from "app/pages/sales-intelligence/modules/lists/types/dto";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

type SavedSearchesListResponse = UseQueryResult<ListsDto<SavedSearchesDto>> & {
    searchText: string;
    page?: number;
    setPage: (page: number) => void;
    setSearchText: (searchText: string) => void;
};

type SavedSearchesRequestParams = {
    initialPage?: number;
    pageSize?: number;
    initSearchText?: string;
};

const useSavedSearchesList = (props?: SavedSearchesRequestParams): SavedSearchesListResponse => {
    const { initialPage, pageSize, initSearchText = "" } = props || {};
    const [page, setPage] = useState<number | undefined>(initialPage);
    const [searchText, setSearchText] = useState<string>(initSearchText);
    const queryData = useQuery({
        queryKey: listsQueryKeys.savedSearches(searchText, page),
        retry: false,
        throwOnError: true,
        queryFn(): Promise<ListsDto<SavedSearchesDto>> {
            return salesApiService.lists.fetchSavedSearches({ page, pageSize, searchText });
        },
    });

    return {
        ...queryData,
        page,
        searchText,
        setSearchText,
        setPage,
    };
};

export default useSavedSearchesList;
